import DashboardPage from "layouts/DashboardPage/DashboardPage";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import DataTable from "components/Tables/DataTable/DataTable";
import TableSkeleton from "components/TableSkeleton/TableSkeleton";
import useWorkOrdersTable from "hooks/fleet/useWorkOrdersTable";
import CreateWorkOrderModal from "components/fleet/CreateWorkOrderModal";
import { Grid } from "@mui/material";

export default function WorkOrdersPage() {
  const { tableData, loading, error, sorting, pagination } = useWorkOrdersTable();

  return (
    <DashboardPage>
      <MDBox mb={3}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MDTypography variant="h4" fontWeight="medium">
              Shop Tasks
            </MDTypography>
          </Grid>
          <Grid item xs={12} lg={6} display="flex" justifyContent="flex-end">
            <CreateWorkOrderModal />
          </Grid>
        </Grid>
      </MDBox>
      <MDBox>
        {loading && <TableSkeleton numberOfLines={pagination.pageSize} />}
        {!loading && !error && (
          <DataTable table={tableData} sorting={sorting} pagination={pagination} isSorted />
        )}
      </MDBox>
    </DashboardPage>
  );
}
